import React from 'react';
import { PawPrint } from 'lucide-react';

const WORDS = [
  'Full Spa', 'Luxurious Baths', 'Kitty Grooming', 'Blueberry Facials', 'Bakery Treats',
  'Birthday Packages', 'De-Shedding', 'Nail Art', 'Therapeutic Massage', 'Breed Styling',
];

// A rotated "sticker tape" of services — bold type, alternating solid/outline.
export default function TrustBar() {
  const row = [...WORDS, ...WORDS];
  return (
    <section aria-label="What we do" className="relative -mt-6 mb-[-1rem] z-10">
      <div className="rotate-[-1.6deg] scale-[1.02] bg-gradient-to-r from-pink-500 via-purple-500 to-cyan-500 shadow-xl shadow-purple-200/50 overflow-hidden py-4">
        <div className="marquee-fast flex w-max items-center">
          {row.map((w, i) => (
            <span key={i} className="flex items-center mx-4 whitespace-nowrap">
              <span className={`font-display text-xl md:text-2xl font-black uppercase tracking-wide ${i % 2 ? 'text-white/40' : 'text-white'}`}>
                {w}
              </span>
              <PawPrint className="w-4 h-4 text-white/50 ml-8" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
